module.exports = __webpack_public_path__ + "static/img/ap13.1bccbec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ap13.jpg
// module id = WojJ
// module chunks = 1